//React
import React, { createContext, useState } from "react";

const initialState = {};

const MattressBuilderContext = createContext(initialState);

const MattressBuilderProvider = props => {
  return (
    <MattressBuilderContext.Provider value={{}}>
      {props.children}
    </MattressBuilderContext.Provider>
  );
};

export { MattressBuilderContext, MattressBuilderProvider };
